module.exports = __webpack_public_path__ + "img/theme6Tran.4c9f25d1.png";